import { Grid2, Radio, TextField, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormControl, FormControlLabel, RadioGroup, FormLabel } from '@mui/material';
import { useMultiStepForm, MoveNext } from "../DataEntry/MultiFormContext";
import { RaceOptions } from "../../common/Constants"

const EmptyProfile = {
  sex: "",
  sex_custom: "",
  race: "",
  race_custom: "",
};

const EditDemographic = ({
  isSubmitting,
  item,
  onChange,
}) => {
  const {
    sex,
    sex_custom,
    race,
    race_custom,
  } = { ...EmptyProfile, ...item };

  const [sexRequiredError, setSexRequiredError] = useState(false)
  const [raceRequiredError, setRaceRequiredError] = useState(false)

  useEffect(() => {
    if (isSubmitting) {
      if (!sex || sex === "") {
        setSexRequiredError(true)
      }
      if (!race || race === "") {
        setRaceRequiredError(true)
      }
    }
  }, [isSubmitting])

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography>
          Providing demographic information helps us tailor our services and secure
          essential funding to support our diverse community. <strong>This data will never
          impact the eligibility</strong> in any way.
        </Typography>
      </Grid2>
       <Grid2 size={6} container>
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Gender</FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="gender"
            value={sex}
            onChange={(e, newValue) => {
              onChange({ sex: newValue });
            }}
          >
            <FormControlLabel value="Male" control={ <Radio />} label="Male" />
            <FormControlLabel value="Female" control={ <Radio />} label="Female" />
            <FormControlLabel value="Other" control={<Radio />} label="Other (please specify)" />
            {sex === "Other" && <TextField
              label="Specify other gender"
              value={sex_custom}
              onChange={(e) => onChange({ sex_custom: e.target.value })}
              margin="dense"
              fullWidth
              variant="outlined"
              size="small"
              required
            />}
          </RadioGroup>
        </FormControl>        
        {sexRequiredError && (!sex || sex === "") && (
          <Typography variant="caption" color="error">Please select an option</Typography>
        )}
      </Grid2>
      <Grid2 size={6}>
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Race</FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="race"
            value={race}
            onChange={(e, newValue) => {
              onChange({ race: newValue });
            }}
          >
            {RaceOptions.map(option => <FormControlLabel value={option.value} label={option.name} control={<Radio />} key={option.name} />)}
            {(race === "Multiple races" || race === "Other race") && <TextField
              label={race === "Multiple races" ? "Specify multiple races" : "Specify other race"}
              value={race_custom}
              onChange={(e) => onChange({ race_custom: e.target.value })}
              margin="dense"
              fullWidth
              variant="outlined"
              size="small"
              required
            />}
          </RadioGroup>
        </FormControl>
        {raceRequiredError && (!race || race === "") && (
          <Typography variant="caption" color="error">Please select an option</Typography>
        )}
       </Grid2>
    </Grid2>
  );
};

export { EditDemographic };
